import { Component } from "@angular/core";

@Component({
  selector: "app-shell-hidden-uif",
  imports: [],
  templateUrl: "./shell-hidden-uif.component.html",
  styles: ``,
})
export class ShellHiddenUifComponent {}
